import { TEMPLATE_TYPES } from "utils/constants";
import ACORIS from "./Acoris";
import B2C_AMELLIS from "./Amellis";
import DEFAULT from "./Default";
import B2C_LMF from "./LMF";
import MILTIS from "./Miltis";
import MILTIS_TER from "./MiltisTer";
import B2C_MUTUAL_MOBILITY from "./MutualMobility";
import RADIANCE from "./Radiance";
import RADIANCE_AURA_TER from "./RadianceAuraTer";
import RADIANCE_COSA from "./RadianceCosa";
import SOLYON from "./Solyon";

const Templates = {
  [TEMPLATE_TYPES.DEFAULT]: DEFAULT,
  [TEMPLATE_TYPES.RADIANCE]: RADIANCE,
  [TEMPLATE_TYPES.RADIANCE_COSA]: RADIANCE_COSA,
  [TEMPLATE_TYPES.RADIANCE_AURA_TER]: RADIANCE_AURA_TER,
  [TEMPLATE_TYPES.B2C_SOLYON]: SOLYON,
  [TEMPLATE_TYPES.B2C_LMF]: B2C_LMF,
  [TEMPLATE_TYPES.B2C_AMELLIS]: B2C_AMELLIS,
  [TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY]: B2C_MUTUAL_MOBILITY,
  [TEMPLATE_TYPES.B2C_MILTIS]: MILTIS,
  [TEMPLATE_TYPES.B2C_MILTIS_TER]: MILTIS_TER,
  [TEMPLATE_TYPES.B2C_ACORIS]: ACORIS,
};
export default Templates;
